/*
 * flashmeeting-fe
 *
 * Author: Andgel BRISSAUD
 * Copyright (c) 2026 Prodeo - All Rights Reserved
 */

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dayjs, FORMAT_DATE_API, RootState, UUID } from '@umanforge/common';
import { useDispatch, useSelector } from 'react-redux';
import BaseModal from '@common_components/modals/baseModal.component';
import { ChartValueService } from 'services/chartValue.service';
import ChartValueGrid from './chartValueGrid.component';

type ChartValueModalProps = {
  isOpen: boolean;
  onClose: () => void;
  chartInfoId: UUID;
  readStart?: string;
  onSaved?: () => void;
};

const ChartValueModal: React.FC<ChartValueModalProps> = ( {
  isOpen,
  onClose,
  chartInfoId,
  readStart,
  onSaved,
} ) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = useSelector( ( state: RootState ) => { return state.token.value; } );
  const [ lastDate, setLastDate ] = useState<string | null>( null );

  useEffect( () => {
    if ( isOpen ) {
      setLastDate( null );
      ChartValueService.getLastDate( chartInfoId, token, dispatch ).then( d => { setLastDate( d ); } );
    }
  }, [ isOpen ] );

  return (
    <BaseModal
      isOpen={ isOpen }
      onClose={ onClose }
      noConfirmationModal={ true }
      title={ t( 'translation:chart_value_grid_tab' ) }
    >
      <div className="px-6 py-4">
        <p className="text-xs text-gray-400 mb-3">
          { lastDate
            ? t( 'translation:chart_value_last_entry', { date: dayjs( lastDate, FORMAT_DATE_API ).format( 'DD/MM/YYYY' ) } )
            : t( 'translation:chart_value_no_value' )
          }
        </p>
        <ChartValueGrid chartInfoId={ chartInfoId } onRefresh={ onSaved } lastDate={ lastDate } readStart={ readStart } />
      </div>
    </BaseModal>
  );
};

export default ChartValueModal;
